import { useMutation, useQueryClient } from "@tanstack/react-query";

import { petsQueryKey } from "@/hooks/queries/useGetPets";
import { petTransactionsQueryKey } from "@/hooks/queries/useGetPetTransactions";
import { guacHttpClient } from "@/lib/http";
import { HttpResponse, Pet, RedeemIncentiveRequest } from "@/types";

// Cashes in one incentive token server-side: guac checks availability and
// writes the INCENTIVE_REDEMPTION ledger row atomically (400 NO_TOKENS if
// nothing to spend), so the client never gates on stale token math.
export const useRedeemIncentive = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      userId,
      ...redemption
    }: { userId: number } & RedeemIncentiveRequest) => {
      const path = `pets/${userId.toString()}/redeem-incentive`;
      const res = await guacHttpClient.post<
        Pet,
        HttpResponse<Pet>,
        RedeemIncentiveRequest
      >(path, redemption);
      return res.data;
    },
    onSuccess: (updatedPet) => {
      queryClient.setQueryData<Pet[]>(petsQueryKey, (pets) =>
        pets?.map((pet) =>
          pet.userId === updatedPet.userId ? updatedPet : pet,
        ),
      );
      // The redemption added an amount-0 INCENTIVE_REDEMPTION ledger row.
      void queryClient.invalidateQueries({
        queryKey: petTransactionsQueryKey(updatedPet.userId),
      });
    },
  });
};
